import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const Chapter = ({ num, title, body, i, chapterLabel }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [80, -80]);
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0.2, 1, 1, 0.2]);

  return (
    <div
      ref={ref}
      data-testid={`vision-chapter-${num}`}
      className={`relative flex flex-col gap-6 py-16 lg:flex-row lg:gap-16 ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
    >
      <motion.div style={{ y }} className="relative lg:w-1/3">
        <span className="pointer-events-none block select-none font-mono text-[22vw] font-700 leading-none text-blue-500/[0.06] lg:text-[12vw]">
          {num}
        </span>
      </motion.div>
      <motion.div style={{ opacity }} className="lg:w-2/3 lg:self-center">
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-blue-400" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-blue-400">{chapterLabel} {num}</span>
        </div>
        <h3 className="font-display text-3xl font-800 leading-tight tracking-tighter text-white sm:text-4xl lg:text-5xl">
          {title}
        </h3>
        <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-[#8AA0C0] sm:text-lg">
          {body}
        </p>
      </motion.div>
    </div>
  );
};

export const Vision = () => {
  const { t } = useLang();
  const chapters = t("vision.chapters");
  return (
    <section id="vision" data-testid="vision-section" className="relative overflow-hidden py-24 lg:py-32">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(0,71,171,0.15),transparent_55%)]" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <span className="font-mono text-xs uppercase tracking-[0.35em] text-blue-400">[ {t("vision.tag")} ]</span>
        <div className="mt-6 divide-y divide-blue-500/10">
          {chapters.map((ch, i) => (
            <Chapter key={i} num={String(i + 1).padStart(2, "0")} title={ch.title} body={ch.body} i={i} chapterLabel={t("vision.chapterLabel")} />
          ))}
        </div>
      </div>
    </section>
  );
};
